var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3H9.7125C9.525 2.1375 8.775 1.5 7.875 1.5C6.975 1.5 6.225 2.1375 6.0375 3H0.75V3.75H6.0375C6.225 4.6125 6.975 5.25 7.875 5.25C8.775 5.25 9.525 4.6125 9.7125 3.75H11.25V3ZM7.875 4.5C7.2375 4.5 6.75 4.0125 6.75 3.375C6.75 2.7375 7.2375 2.25 7.875 2.25C8.5125 2.25 9 2.7375 9 3.375C9 4.0125 8.5125 4.5 7.875 4.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 9H2.2875C2.475 9.8625 3.225 10.5 4.125 10.5C5.025 10.5 5.775 9.8625 5.9625 9H11.25V8.25H5.9625C5.775 7.3875 5.025 6.75 4.125 6.75C3.225 6.75 2.475 7.3875 2.2875 8.25H0.75V9ZM4.125 7.5C4.7625 7.5 5.25 7.9875 5.25 8.625C5.25 9.2625 4.7625 9.75 4.125 9.75C3.4875 9.75 3 9.2625 3 8.625C3 7.9875 3.4875 7.5 4.125 7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsProducts);
export default __webpack_public_path__ + "static/media/settingsProducts.37d83fce0c26c0b78fc5bd280c8b6308.svg";
export { ForwardRef as ReactComponent };